import React from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import BookingRequestPage from "./BookingRequestPage";

export default function CustomerPortalNewRequest() {
  const { customer } = useOutletContext();
  const navigate = useNavigate();

  return (
    <div className="w-full p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">New Booking Request</h1>
        <p className="text-sm text-gray-500 mt-1">Submit a new livestock, freight or machinery booking request.</p>
      </div>

      <div className="rounded-xl border border-gray-200 bg-white shadow-sm p-6">
        <BookingRequestPage
          embedded
          fixedCustomerId={customer._id}
          onSubmitted={() => {
            setTimeout(() => navigate("/portal"), 2000);
          }}
        />
      </div>
    </div>
  );
}
